export const formatTime = (seconds) => {
    if (!seconds || seconds < 0) return "00:00";
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
};

export const startCountdown = (limit, onTick) => {
    let remainingTime = limit;

    onTick(remainingTime);

    const timer = setInterval(() => {
        remainingTime -= 1;
        onTick(remainingTime);

        if (remainingTime > 0) {
            onTick(remainingTime);
        } else {
            onTick(0); // last tick
            clearInterval(timer);
        }
    }, 1000);

    return () => clearInterval(timer);
};

export const formatTimeMiliSecond = (ms) => {
    if (!ms || ms < 0) return "00:00";
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

export const isFullScreen = () => {
  const doc = document;
  return !!(
    doc.fullscreenElement ||
    doc.webkitFullscreenElement ||
    doc.mozFullScreenElement ||
    doc.msFullscreenElement
  );
};

export const toggleFullScreen = async () => {
  const doc = document;
  const docEl = document.documentElement;

  try {
    if (!isFullScreen()) {
      // ENTER FULLSCREEN
      if (docEl.requestFullscreen) {
        await docEl.requestFullscreen();
      } else if (docEl.webkitRequestFullscreen) {
        await docEl.webkitRequestFullscreen(); // Safari
      } else if (docEl.mozRequestFullScreen) {
        await docEl.mozRequestFullScreen(); // Firefox old
      } else if (docEl.msRequestFullscreen) {
        await docEl.msRequestFullscreen(); // IE/Edge old
      } else {
        console.warn("Fullscreen API not supported in this browser.");
      }
    } else {
      // EXIT FULLSCREEN
      if (doc.exitFullscreen) {
        await doc.exitFullscreen();
      } else if (doc.webkitExitFullscreen) {
        await doc.webkitExitFullscreen(); // Safari
      } else if (doc.mozCancelFullScreen) {
        await doc.mozCancelFullScreen(); // Firefox old
      } else if (doc.msExitFullscreen) {
        await doc.msExitFullscreen(); // IE/Edge old
      }
    }
  } catch (err) {
    console.error("Fullscreen toggle error:", err);
  }
};

export const isDarkMode = () => {
  return document.documentElement.getAttribute("data-theme") === "dark";
};

export const toggleTheme = () => {
  const currentTheme = document.documentElement.getAttribute("data-theme");
  document.documentElement.setAttribute(
    "data-theme",
    currentTheme === "dark" ? "light" : "dark"
  );
};
